"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var BrandLogo = function BrandLogo(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      provider = _ref.provider;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-24 w-24 rounded-full mb-3",
    src: src || t("retrofit.provider.".concat(provider || 'other', ".icon")),
    alt: alt || t("retrofit.provider.".concat(provider || 'other', ".name"))
  });
};

var _default = BrandLogo;
exports["default"] = _default;
//# sourceMappingURL=BrandLogo.js.map